export const PRODUCT_TYPE = [
  { id: 'AUTOCALL', displayValue: 'Autocallable' },
  {
    id: 'AUTOCALL_GROWTH_AT_MATURITY',
    displayValue: 'Autocallable (Growth at Maturity)',
  },
  { id: 'BONUS_CERTIFICATE', displayValue: 'Bonus Certificate' },
  { id: 'CAPPED_FLOOR_DELTA_N', displayValue: 'Capped Floor Delta N' },
  { id: 'CHOOSER', displayValue: 'Chooser' },
  { id: 'CLN', displayValue: 'CLN' },
  { id: 'DISCOUNT_CERTIFICATE', displayValue: 'Discount Certificate' },
  { id: 'DROPBACK_CERTIFICATE', displayValue: 'Drop-Back Certificate' },
  { id: 'DUAL_CURRENCY_NOTE', displayValue: 'Dual Currency Note' },
  { id: 'EQ_ISSUER_CALLABLE', displayValue: 'Issuer Callable - Equity' },
  { id: 'FIXED_RATE_NOTE', displayValue: 'Fixed Rate Note' },
  { id: 'FLOATING_RATE_NOTE', displayValue: 'Floating Rate Note' },
  { id: 'FX_DIGITAL_COUPON_NOTE', displayValue: 'FX Digital Coupon Note' },
  { id: 'PARTICIPATION_NOTE', displayValue: 'Participation Note' },
  {
    id: 'PERFORMANCE_LINKED_COUPON',
    displayValue: 'Performance-linked Coupon',
  },
  { id: 'PRDC', displayValue: 'PRDC' },
  { id: 'REVERSE_CONVERTIBLE', displayValue: 'Reverse Convertible' },
  {
    id: 'REVERSE_CONVERTIBLE_BOND',
    displayValue: 'Reverse Convertible - Bond',
  },
  { id: 'SUPERTRACKER', displayValue: 'Supertracker' },
  {
    id: 'FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE',
    displayValue: 'Fixed to Floating/Floating to Fixed Rate Note',
  },
  {
    id: 'RANGE_ACCRUAL',
    displayValue: 'Range Accrual',
  },
  {
    id: 'WARRANT',
    displayValue: 'Warrant',
  },
].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
